import store from '@/store/store';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Messages from '@/assets/ts/utils/Messages';
import Util from '@tekvue/assets/utils/Util';
import { VinculoMesa } from '@/views/MesaOperacoes/types-mesa';
import User from '../interfaces/User';

export default class MesaOperacoesController {
  public static async getMesaOperacoes(
    data: string,
    unidade: string,
    showLoading = true,
  ): Promise<VinculoMesa[]> {
    const route = 'getMesaOperacoes';

    const user: User = store.getters.user;
    const nrOrg = user.nrorg;

    const params = {
      requestType: 'FilterData',
      DIA: data,
      NRESTRUTURAM: unidade,
      NRORG: nrOrg,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    return response.data.dataset.data;
  }
}
